const EIRA_CDN = 'https://neoterra-site.b-cdn.net/project/eira';

export const visualBedroom = `${EIRA_CDN}/1%20bed%20bedroom%2020%20series.jpg`;
export const visualLivingRoom = `${EIRA_CDN}/1%20bed%20living%20room%2020%20series.jpg`;
export const visualBuildingFacade = `${EIRA_CDN}/Building%20facade%20-%20Lake%20view.jpg`;
export const visualClubSerene = `${EIRA_CDN}/Club%20Serene.jpg`;
export const eiraBrochurePdf = `${EIRA_CDN}/Eira%20Brochure.pdf`;
export const visualSerenityWalkway = `${EIRA_CDN}/Serenity%20Walkway.jpg`;
